import { FC } from 'react'
import { ListItemAvatar, ListItemText, Typography, useTheme, ListItem, SvgIconProps } from '@mui/material'
import { CircleDiv } from '../../Divs'

interface HIWListItemProps {
  avatarContent: string | number,
  title: string,
  description: string,
  icon: any
}

export const HIWListItem: FC<HIWListItemProps> = ({avatarContent, title, description, icon}) => {
  const theme = useTheme()
  return (
    <ListItem>
      <ListItemAvatar sx={{alignSelf:'flex-start'}}>
        <CircleDiv>{avatarContent}</CircleDiv>
      </ListItemAvatar>
      <ListItemText sx={{display: 'block'}}>
        {icon}

        <Typography sx={{fontWeight:600}}>{title}</Typography>
        <Typography >{description}</Typography>
      </ListItemText>
    </ListItem>
  )
}